export default {
  data: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/TiposFinalizacao/components/search/search-form.js